import { Injectable } from '@angular/core';
import { VaultApiService } from '@app/core/services/api/vault-api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocalizationApiService {
  private endpointBase: string = 'users/localization';
  constructor(private apiService: VaultApiService) {}

  currentServerDate(): Observable<Date | null> {
    return this.apiService.get<Date>(`${this.endpointBase}/datetime/utc-now`);
  }
}
